import { TokenUtils } from '@philips-emr/hpms-provider-commons';
import providerContext from '@philips-emr/hpms-provider-commons/lib/context/provider-context';
import { ThemeTonalRange } from '@philips-emr/tws-constants';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { ThemeService } from '@philips-emr/tws-core/lib/services';
import { applicationContext } from '@philips-emr/tws-foundation/lib/context';

import { FOUNDATION_ROUTES } from '../route';

import BaseController from './BaseController';

@Controller({ fragment: 'redirect' })
export default class RedirectControler extends BaseController {

  @OnMount({ target: 'panel-redirect' })
  onMount(): void {
    ThemeService.setContentTonalRange(ThemeTonalRange.ULTRA_LIGHT);
    const selectedProvider = providerContext.getSelectedProvider().nrSeqProvider;
    const { defaultProvider } = TokenUtils.getValues();
    providerContext.setSelectedProvider(selectedProvider ? selectedProvider : Number(defaultProvider));
    applicationContext.clearNavigationStack();
    this.historyService.push(FOUNDATION_ROUTES.DASHBOARD);
  }
}
